import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-regenerate-sshkey>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname} submitfunc={submitHandler}>
  
    <yield to="fields">
      <div class="row">
        <div class="col-md-12">
          <p>Der SSH-Schlüssel für die Verbindung zu dem <strong> '{parent.patient}' </strong> System wird neu erstellt.</p>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12">
          <div class="mt-2 mr-1 p-2 border border-info">
              <span><paedml-icon icon="fas-info-circle" simple="info" />
                  <strong class="text-info pl-1 pt-2">Die Erstellung des SSH-Schlüssels kann einige Minuten dauern.</strong>
              </span>
              </div>
          <div class="p-2"></div>
          </div>
      </div>
    </yield>
  </paedml-modal>
    
    <script>
      import { handleSubmitCreateOrEdit } from '../../util/api-util'
      
      this.opname = this.opts.opname
      this.data = {}
      this.edit = true
      this.api = this.opts.api
      this.patient = opts.patient

      this.submitHandler = formData => {
      
      return this.api.sshKey().then(rsp => {
        const [data, status] = rsp
        if (status.error) return Promise.reject('Kommunikationsfehler mit dem Server')

        if(status.success){
          this.parent.trigger('reloadTable')
          return 'Der Job zur Erstellung des SSH-Schlüssels wurde erfolgreich gestartet.'
        }
      })
    }
    </script>
</paedml-modal-regenerate-sshkey>
